import type { Editor } from ".";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Modal } from "@/react/components/shared/uikit/ModalV2";

export const ModalFooter = ({ onClose }: { onClose: () => void }) => {
  const { watch } = useFormContext();
  const selectedEditor: Editor = watch("editor") as Editor;

  return (
    <Modal.Footer>
      <div className="flex items-stretch justify-end space-x-4">
        <Button
          type="button"
          variant="secondary"
          onClick={() => {
            onClose();
          }}
        >
          {t("cancel")}
        </Button>
        <Button type="submit" variant="circle" disabled={!selectedEditor}>
          {t("continue")}
        </Button>
      </div>
    </Modal.Footer>
  );
};
